import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription, Observable } from 'rxjs';

import { Quote } from '../model/quote';
import { Customer } from '../model/customer';
import { SelectedOption } from '../model/selected-option';
import { OrderInformation } from '../model/order-information';
import { Adjustment } from '../model/adjustment';
import { QuoteRevision } from '../model/quote-revision';

import { QuoteRevisionInfoService } from '../services/quote-revision-info.service';

@Component({
  selector: 'app-quote-compare-column',
  template: require('./quote-compare-column.component.html'),
  styles: [require('./quote-compare-column.component.scss')]
})
export class QuoteCompareColumnComponent implements OnInit, OnDestroy {
  @Input() quoteId: number;
  quoteRevisions: QuoteRevision[];
  combinedRevisionUsers: string[];
  firstRevisionCompare: number;
  secondRevisionCompare: number;
  quotes: Quote[];
  selectedOptions: SelectedOption[];
  orders: OrderInformation[];
  adjustments: Adjustment[];
  customers: Customer[];
  isModelProductUpdated: boolean;
  subscription: Subscription = new Subscription();

  constructor(private quoteRevisionInfoService: QuoteRevisionInfoService) {}

  ngOnInit(): void {
    const quoteRevisionInfo = Observable.combineLatest(
      this.quoteRevisionInfoService._quoteRevisions$,
      this.quoteRevisionInfoService._combinedRevisionUsers$,
      this.quoteRevisionInfoService._firstRevisionCompare$,
      this.quoteRevisionInfoService._secondRevisionCompare$,
      this.quoteRevisionInfoService._quotes$,
      this.quoteRevisionInfoService._orders$,
      this.quoteRevisionInfoService._selectedOptions$,
      this.quoteRevisionInfoService._adjustments$,
      this.quoteRevisionInfoService._customers$,
      this.quoteRevisionInfoService._isModelProductUpdated$
    ).subscribe(data => {
      this.quoteRevisions = data[0];
      this.combinedRevisionUsers = data[1];
      this.firstRevisionCompare = data[2];
      this.secondRevisionCompare = data[3];
      this.quotes = data[4];
      this.orders = data[5];
      this.selectedOptions = data[6];
      this.adjustments = data[7];
      this.customers = data[8];
      this.isModelProductUpdated = data[9];
    });
    this.subscription.add(quoteRevisionInfo);
  }

  onChangeFirstRevisionCompare(e) {
    this.quoteRevisionInfoService._firstRevisionCompare$.next(+e.target.value);
  }

  onChangeSecondRevisionCompare(e) {
    this.quoteRevisionInfoService._secondRevisionCompare$.next(+e.target.value);
  }

  getColor(value, comparedValue, isFirstColumn = false) {
    // If both values are the same
    // OR value does not exist against the other revision value
    if (value === comparedValue || value === null || value === '') {
      return '';
    }
    // comparedValue either does not exist or value was not changed in that revision
    if ((value || value === 0) && comparedValue === null) {
      return '#5cb85c';
    }
    // Comparing number quantity & price
    if (Number.isInteger(+value) && Number.isInteger(+comparedValue)) {
      if (+value > +comparedValue) {
        return '#5cb85c';
      }
      return '#d9534f';
    }

    if (this.secondRevisionCompare > this.firstRevisionCompare) {
      // Comparing string values
      // Checks if there is an update to the value in the compared against revision
      if (comparedValue && typeof comparedValue === 'string' && isFirstColumn) {
        return '#d9534f';
      }
      return '#5cb85c';
    } else {
      if (isFirstColumn) {
        return '#5cb85c';
      }
      if (!comparedValue) {
        return '#5cb85c';
      }
      return '#d9534f';
    }
  }

  onToggleAside() {
    this.quoteRevisionInfoService._showQuoteRevisionsAside$.next(true);
  }

  toggleRevertRevisionAside(revisionNumber?: number) {
    if (revisionNumber) {
      this.quoteRevisionInfoService.revertRevisionNumber$.next(revisionNumber);
    }
    this.quoteRevisionInfoService.quoteId$.next(this.quoteId);
    this.quoteRevisionInfoService._showRevertRevisionAside$.next(true);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/quote-compare-column/quote-compare-column.component.ts